module.exports = __webpack_public_path__ + "img/black03.e83ac920.png";